"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKILL_RESOURCE_TOOL_NAMES = exports.MAX_SKILL_ERROR_JSON_BYTES = exports.MAX_SKILL_TOOL_ARGS_JSON_BYTES = exports.MAX_SKILL_CATALOG_JSON_BYTES = exports.MAX_SKILL_BYTES = exports.MAX_SKILL_PATH_LENGTH = exports.MAX_SKILL_FILES = exports.SKILL_PRODUCTION_LABEL = exports.SKILL_LATEST_LABEL = void 0;
exports.SKILL_LATEST_LABEL = "latest";
exports.SKILL_PRODUCTION_LABEL = "production";
exports.MAX_SKILL_FILES = 200;
exports.MAX_SKILL_PATH_LENGTH = 512;
exports.MAX_SKILL_BYTES = 1_000_000;
exports.MAX_SKILL_CATALOG_JSON_BYTES = 64 * 1024;
exports.MAX_SKILL_TOOL_ARGS_JSON_BYTES = 16 * 1024;
exports.MAX_SKILL_ERROR_JSON_BYTES = 4 * 1024;
exports.SKILL_RESOURCE_TOOL_NAMES = new Set([
    "skill",
    "Skill",
    "loadSkill",
    "skill_read",
    "readFile",
    "Read",
]);
